module.exports = __webpack_public_path__ + "static/img/28.bb6241f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/28.png
// module id = 6Dvr
// module chunks = 0